import * as actionTypes from "../actionTypes";
const initialState = {
  mentor: [],
  industries: [],
  error: null,
};
const mentorReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_MENTORS:
      return {
        ...state,
        mentor: payload,
      };
    case actionTypes.MENTORS_SUCCESS:
      return {
        ...state,
        mentor: payload,
      };
    case actionTypes.MENTORS_FAIL:
      return {
        ...state,
        error: "asdasdasdas",
      };
    case actionTypes.GET_INDUSTRIES:
      return {
        ...state,
        industries: [],
      };
    case actionTypes.GET_INDUSTRIES_SUCCESS:
      return {
        ...state,
        industries: payload,
      };
    case actionTypes.GET_INDUSTRIES_FAIL:
      return {
        ...state,
        error: "asdasdasdas",
      };
    default:
      return state;
  }
};
export default mentorReducer;
